export default "__VITE_ASSET__xe3Ip29$__"